
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BookmarkPlus, Save } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface SaveAddressButtonProps {
  onSave: (label: string) => Promise<void>;
  prefix: string;
}

export const SaveAddressButton = ({ onSave, prefix }: SaveAddressButtonProps) => {
  const [showLabelInput, setShowLabelInput] = useState(false);
  const [label, setLabel] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const isMobile = useIsMobile();

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(label);
      setShowLabelInput(false);
      setLabel("");
    } finally {
      setIsSaving(false);
    }
  };

  if (!showLabelInput) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={() => setShowLabelInput(true)}
      >
        <BookmarkPlus className="h-4 w-4 mr-2" />
        {isMobile ? "Save" : "Save to Address Book"}
      </Button>
    );
  }

  return (
    <div className="flex gap-2 items-end">
      <div className="space-y-1">
        <Label htmlFor={`${prefix}-label`} className="text-xs">Label (optional)</Label>
        <Input
          id={`${prefix}-label`}
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="e.g., Home, Work"
          className="h-8 w-full"
          style={{ minWidth: isMobile ? "120px" : "160px" }}
        />
      </div>
      <Button
        size="sm"
        onClick={handleSave}
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Save"}
      </Button>
    </div>
  );
};
